import { createAction, createActionGroup, props } from "@ngrx/store";
import { Auth } from "../../auth/primitives/auth";
import { Vector2, Vector3 } from "three";
import {Chat, Message, Participant} from "./chat.model";

export const ChatActions = createActionGroup({
  source: "Chats",
  events: {
    "Found Chat": props<{ chat: Chat }>(),
    "Found Multiple Chats": props<{ chats: Chat[] }>(),
    "New Chat": props<{ name: string, ownerId: string, participants: string[]}>(),
    "Found Participants": props<{ participants: Participant[] }>(),
    "Found Participant": props<{ participant: Participant }>(),
    "Found Message": props<{ message: Message }>(),
    "Found Multiple Messages": props<{ messages: Message[] }>(),
    "Update Last Seen": props<{ chatId: string, userId: string }>(),
    "New Message": props<{
      chatId: string,
      text: string,
      ownerId: string,
      components?: string[],
      componentProperties?: any,
      tags?: string[]
    }>(),
  },
});



